import { Colors } from "@blueprintjs/core";
import React, { ChangeEvent, ReactNode } from "react";
import { styled } from "styled-components";

type InputFieldPropsT = {
	label?: string;
	name: string;
	type: string;
	value: string;
	onChange: (e: ChangeEvent<HTMLInputElement>) => void;
	inputContainerClass?: string;
	placeholder?: string;
	disabled?: boolean;
	mt?: string;
	mb?:string;
	ptb?: string;
	bradius?: string;
	elem?: ReactNode;
}

const InputField: React.FC<InputFieldPropsT> = ({
	label,
	name,
	type,
	value,
	onChange,
	inputContainerClass,
	placeholder = "Please Input",
	disabled = false,
	mt = "3px",
	mb = '0px',
	ptb = "10px",
  bradius="10px",
	elem,
}) => {
	return (
		<div className={inputContainerClass ?? "mt-xlg"}>
			<div className={elem ? "display-flex align-center":""}>
			{label && <Label htmlFor={name}>{label}</Label>}
			{elem ? elem : <></>}
			</div>
			<CustomInputField
				name={name}
				value={value}
				onChange={onChange}
				placeholder={placeholder}
				disabled={disabled}
				type={type}
				mt={mt}
				mb={mb}
				ptb={ptb}
				bradius={bradius}

			/>
		</div>
	);
};

export default InputField;

const Label = styled.label`
    fontSize: "15px";
    color: ${({ theme: { darkMode } }) => darkMode ? Colors.GRAY5 : Colors.GRAY1};
`;
const CustomInputField = styled.input<{ mt?: string , ptb: string, bradius?: string, mb?: string }>`
    width: 100%;
    background-color: ${({ theme: { darkMode } }) => darkMode ? Colors.DARK_GRAY3 : Colors.LIGHT_GRAY5};
    border: 1px solid ${({ theme: { darkMode } }) => darkMode ? Colors.GRAY1 : Colors.LIGHT_GRAY3};
    font-size: 15px;
    border-radius: ${({ bradius }) => bradius ?? "10px"};
    color: ${({ theme: { darkMode } }) => darkMode ? Colors.GRAY4 : Colors.GRAY2};
	padding: ${({ ptb }) => `${ptb} 15px`};
    margin-top: ${({ mt }) => mt ?? "3px"};
    margin-bottom: ${({ mb }) => mb ?? "0"};
    &:focus-visible{
      outline: none;
    }
    &::placeholder{
      color: ${({ theme: { darkMode } }) => darkMode ? Colors.GRAY1 : Colors.LIGHT_GRAY1};
    }
`;
